<ng-content select="lumiron-card-header"></ng-content>
<ng-content select="lumiron-card-body"></ng-content>
<ng-content select="lumiron-card-footer"></ng-content>
@if (backgroundImage(); as image) {
<img [ngSrc]="image" fill placeholder alt="" />
}
